import React from "react";
import { Redirect } from "react-router-dom";
import {
  getFlagForAppraisalPath,
  isAppraisalFeatureEnabled,
  useAppraisalFeatures,
} from "./appraisalFeatures";
import { canAccessMyAppraisal, getAppraisalHomePath } from "./appraisalAccess";

/**
 * Blocks optional appraisal pages when the company feature flag is off.
 * Core pages (overview, settings, framework, team, self, evidence, assessment) pass through.
 */
const AppraisalFeatureGate = ({ flag, path, children }) => {
  const { features, loading } = useAppraisalFeatures();
  const resolvedFlag = flag || getFlagForAppraisalPath(path);

  if (!resolvedFlag) return children;
  if (loading) {
    return <div className="appraisal-muted" style={{ padding: "1rem" }}>Loading…</div>;
  }
  if (!isAppraisalFeatureEnabled(features, resolvedFlag)) {
    return <Redirect to={getAppraisalHomePath()} />;
  }
  return children;
};

export default AppraisalFeatureGate;
